// src/i18n.js
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend'; // ✅ Backend loader

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
    ns: ['common', 'swap', 'liquidity', 'history', 'defi'], // ✅ all namespaces you're using
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: true
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage']
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json' // ✅ matches your folder structure
    }
  });

// Optional debug helper
window.debugTranslation = (key, ns = 'common') => {
  const fullKey = ns ? `${ns}:${key}` : key;
  const translation = i18next.t(fullKey);
  console.log(`"${fullKey}" → "${translation}"`);
  return translation;
};

export default i18next;
